import { ApiError, handleApiError } from '@/handleApiError'
import api from '@/modules/authentication/api'
import { Password } from '@/modules/user/types'
import { t } from '@/plugins/i18n.ts'
import { CustomTerms, InvitationRegistration, Token, ValidTokenDto } from '@/types/index'
import { defineStore } from 'pinia'

interface Registration {
  registrationData: ValidTokenDto | undefined
  customTerms: CustomTerms
  tokenError: boolean
  sending: boolean
  loading: boolean
}

const initialState = (): Registration => {
  return {
    registrationData: undefined,
    customTerms: {
      isCustomTerms: false,
      terms: ''
    },
    tokenError: false,
    sending: false,
    loading: false
  }
}

const useRegistration = defineStore('registration', {
  state: () => initialState(),
  actions: {
    async getCustomTerms(lang: string) {
      this.loading = true

      return api
        .getCustomTerms(lang)
        .then(({ data }) => {
          this.customTerms = data
        })
        .catch(handleApiError)
        .finally(() => (this.loading = false))
    },
    async checkRegisterToken(dto: Token) {
      this.loading = true

      return api
        .checkRegisterToken(dto)
        .then(({ data }) => {
          this.registrationData = data
          this.tokenError = false
        })
        .catch((error: ApiError) => {
          if (error.code === 400 || error.code === 401) {
            // token not valid
            this.tokenError = true
          } else {
            // other error
            handleApiError(error)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    async finishRegistration(dto: InvitationRegistration) {
      this.sending = true

      return api
        .finishRegistration(dto)
        .then(({ data }) => {
          this.tokenError = false
          window.location.assign('/autologin?token=' + data)
        })
        .catch((error: ApiError) => {
          handleApiError(error, {
            customMessage: t('error.registration')
          })
        })
        .finally(() => {
          this.sending = false
        })
    },
    async guestRegistration(dto: Password) {
      this.sending = true

      return api
        .guestRegistration(dto)
        .then(({ data }) => {
          window.location.assign('/autologin?token=' + data)
        })
        .catch((error: ApiError) => {
          handleApiError(error, {
            customMessage: t('error.registration')
          })
        })
        .finally(() => {
          this.sending = false
        })
    }
  }
})

export default useRegistration
